const SCOPES = {
  confirmed: 'confirmed',
  suspected: 'suspected',
  possible: 'possible',
}

export function sortOnName(a, b) {
  if (a.name === b.name) {
    return 0
  }
  if (a.name.length !== b.name.length) {
    return a.name.length - b.name.length
  }
  return b.name > a.name ? -1 : 1
}

/** format nested history to a flattened array */
export function historyFormatting(history) {
  if (!Array.isArray(history)) {
    return history
  }

  const out = []

  const normalizeItem = item => ({
    id: item.id,
    name: item?.name?.toUpperCase(),
    merged: item.merged,
    attribution_scope: SCOPES.confirmed,
  })

  const flatten = history => {
    history.filter(x => x).forEach(item => {
      out.push(normalizeItem(item))
      if (item.history) {
        flatten(item.history)
      }
    })
    return out
  }

  return flatten(history).sort(sortOnName)
}

export function suspectedGroupsFormatting(suspectedGroups) {
  if (!Array.isArray(suspectedGroups)) {
    return suspectedGroups
  }

  return suspectedGroups.filter(x => x).map(item => ({
    id: item.id,
    name: item?.name?.toUpperCase(),
    applied: item.applied,
    attribution_scope: item.attribution_scope,
  })).sort(sortOnName)
}

export function actorHistoryAdapter(data) {
  if (!data) return data

  const decorated = {}

  decorated.id = data.id
  decorated.name = data.name
  decorated.history = historyFormatting(data.history)
  decorated.suspectedGroups = suspectedGroupsFormatting(data.suspected_groups)
  decorated.meta = {
    hasGroupAssociations:
        !!decorated.history.length && !!decorated.suspectedGroups.length
  }
  return decorated
}
